export default __webpack_public_path__ + "static/menu-do-dark-6b34346ac965cafc1ffbccf322697143a8d9e4bda0f48a8abf8ea26f88646aa4.png";